var cov_vo5h8k242 = function () {
  var path = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Popover/context.tsx",
      hash = "f38a0d5e068554a9d8fa61631b83030280098f13",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Popover/context.tsx",
    statementMap: {
      "0": {
        start: {
          line: 5,
          column: 16
        },
        end: {
          line: 5,
          column: 78
        }
      },
      "1": {
        start: {
          line: 7,
          column: 21
        },
        end: {
          line: 7,
          column: 28
        }
      },
      "2": {
        start: {
          line: 10,
          column: 24
        },
        end: {
          line: 10,
          column: 40
        }
      },
      "3": {
        start: {
          line: 12,
          column: 25
        },
        end: {
          line: 14,
          column: 1
        }
      },
      "4": {
        start: {
          line: 12,
          column: 68
        },
        end: {
          line: 14,
          column: 1
        }
      },
      "5": {
        start: {
          line: 13,
          column: 2
        },
        end: {
          line: 13,
          column: 86
        }
      },
      "6": {
        start: {
          line: 13,
          column: 26
        },
        end: {
          line: 13,
          column: 74
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 12,
            column: 25
          },
          end: {
            line: 12,
            column: 26
          }
        },
        loc: {
          start: {
            line: 12,
            column: 68
          },
          end: {
            line: 14,
            column: 1
          }
        },
        line: 12
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 12,
            column: 68
          },
          end: {
            line: 12,
            column: 69
          }
        },
        loc: {
          start: {
            line: 13,
            column: 2
          },
          end: {
            line: 13,
            column: 86
          }
        },
        line: 13
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 13,
            column: 13
          },
          end: {
            line: 13,
            column: 14
          }
        },
        loc: {
          start: {
            line: 13,
            column: 26
          },
          end: {
            line: 13,
            column: 74
          }
        },
        line: 13
      }
    },
    branchMap: {},
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0
    },
    b: {},
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

var _this = this,
    _jsxFileName = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Popover/context.tsx";

import React from 'react';
import createReactContext from '../context';
var context = (cov_vo5h8k242.s[0]++, createReactContext(undefined));

var _ref = (cov_vo5h8k242.s[1]++, context),
    Consumer = _ref.Consumer; // eslint-disable-next-line


export var Provider = (cov_vo5h8k242.s[2]++, context.Provider);
cov_vo5h8k242.s[3]++;
export var consumer = function consumer(Origin) {
  cov_vo5h8k242.f[0]++;
  cov_vo5h8k242.s[4]++;
  return function (props) {
    cov_vo5h8k242.f[1]++;
    cov_vo5h8k242.s[5]++;
    return (
      /*#__PURE__*/
      React.createElement(Consumer, {
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 13,
          columnNumber: 3
        }
      }, function (bindChain) {
        cov_vo5h8k242.f[2]++;
        cov_vo5h8k242.s[6]++;
        return (
          /*#__PURE__*/
          React.createElement(Origin, Object.assign({}, props, {
            bindChain: bindChain,
            __self: _this,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 13,
              columnNumber: 27
            }
          }))
        );
      })
    );
  };
};